import { render, staticRenderFns } from "./problemAdd.vue?vue&type=template&id=f28abf4c&scoped=true"
import script from "./problemAdd.vue?vue&type=script&lang=js"
export * from "./problemAdd.vue?vue&type=script&lang=js"
import style0 from "./problemAdd.vue?vue&type=style&index=0&id=f28abf4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28abf4c",
  null
  
)

export default component.exports